<div *ngIf="!isMultipleNotification">
    <h5>{{notificationData.notificationTitle}}</h5>
    <p innerHTML="{{ notificationData.notificationMessage }}"></p>
    <span> {{notificationData.notificationTillNow}} </span>

    <span style="float:right;">
        <div kendoTooltip class="grid-tooltip">
            <span> {{notificationData.notificationDate | localDateTime}}</span>
        </div>
    </span>
</div>
<div *ngIf="isMultipleNotification">
    <h5>You have total <b>{{notificationUnreadCount}}</b> unread notifications to check please review it.</h5>
</div>